var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "aria-hidden": "true", tabindex: "-1" } },
    [
      _c(
        "b-modal",
        { attrs: { id: "feature-toggles", title: "Features", "ok-only": "" } },
        [
          _c(
            "ul",
            _vm._l(_vm.features, function (toggle, index) {
              return _c(
                "li",
                { key: index },
                [
                  _c("feature-toggle", {
                    key: _vm.forceRerender,
                    attrs: { name: toggle.name },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-outline-primary mt-1",
              on: {
                click: function ($event) {
                  return _vm.resetState()
                },
              },
            },
            [_vm._v("\n            Lokales Cookie zurücksetzen\n        ")]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showTab
        ? _c(
            "a",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal:feature-toggles",
                  arg: "feature-toggles",
                },
              ],
              staticClass: "feature-toggle-trigger",
              attrs: { href: "#", "aria-hidden": "true", tabindex: "-1" },
            },
            [
              _vm._v("Features "),
              _c("span", { staticClass: "badge badge-light" }, [
                _vm._v(
                  _vm._s(_vm.enabledToggles.length) +
                    "/" +
                    _vm._s(_vm.allToggles.length)
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }